import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
// import $ from 'jquery'

// Components
import { ResizeDetector } from './ResizeDetector'
import EmbedView from '../../shared/components/EmbedView'
import IntroView from './IntroView'
import CarDataView from './CarDataView'
import UploadPhotoView from './UploadPhotoView'
import OtherInfoView from './OtherInfoView'
import ContactInfoView from './ContactInfoView'
import SendView from './SendView'

import RenderFontURL from '../../shared/components/RenderFontURL'

// // Elements
// import Icon from '../../shared/elements/icon'
// import { EmbeddedBookingIcons } from '../../shared/elements/icons'

import { translation } from '../../utils/helpers'
import { formatDate } from '../../utils/time'

// actions
import { saveEmbeddedBooking, setEmbeddedInsuranceCompanies, setEmbeddedCarRentalAlts, getBookingPortalRedirectUrlFromToken } from '../../actions/embeddedbooking'
import { getInsuranceCompanies } from '../../actions/insurancecompanies'
import { loginWithToken, logout, getStyle } from '../../actions/embedded'
import { GetCarRentalAlts } from '../../actions/carrentalalternatives'
// import { getStylePortalWeb } from '../../actions/settings'

// Styles
import './embeddedbooking.scss'

class EmbeddedBooking extends Component {

  constructor (props) {
    super(props)
    this.state = {
      stepId: 0,
      embedViewState: null,
      companyData: null,
      countryCode: '',
      flowType: 'with_regnr',
      isLoading: false,
      styles: {
        FontType: 1,
        WebSafeFont: 'Verdana',
        FontURL: '',
        FontFamily: 'unset',
        BrandColor: '#000000',
        BrandColorSecondary: '#000000',
        PrimaryBackgroundColor: '#000000',
        ColoredBackground: '#000000',
        H1Size: 20,
        H1Color: '#000000',
        H2Size: 18,
        H2Color: '#000000',
        BodySize: 14,
        BodyColor: '#000000',
        NavigationSize: 0,
        NavigationColor: '#000000',
        LinkSize: 14,
        LinkColor: '#000000',
        ButtonTextSize: 14,
        ButtonTextColor: '#000000',
        ButtonStrokeColor: '#000000',
        ButtonFillColor: '#000000',
        HoverStrokeColor: '#000000',
        HoverFillColor: '#000000',
        CheckboxColor: '#000000',
        CheckboxActiveColor: '#000000',
        BackButtonTextSize: 20,
        BackButtonTextColor: '#000000',
        BackButtonStrokeColor: '#000000',
        BackButtonFillColor: '#000000',
        BackButtonHoverStrokeColor: '#000000',
        BackButtonHoverFillColor: '#000000',
        InputFieldColor: '#000000',
        InputFieldTextColor: '#000000',
        EmptyFieldTextColor: '#000000',
        EmptyFieldTextSize: 16
      }
    }

    this.steps = [
      { stepId: 0, stepName: 'Intro' },
      { stepId: 1, stepName: 'UploadPhotoView' },
      { stepId: 2, stepName: 'CarDataView' },
      { stepId: 3, stepName: 'OtherInfoView' },
      { stepId: 4, stepName: 'ContactInfoView' },
      { stepId: 5, stepName: 'SendView' }
    ]

    this.getView = this.getView.bind(this)
    this.onNavClick = this.onNavClick.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.getResetData = this.getResetData.bind(this)
    this.onLoginComplete = this.onLoginComplete.bind(this)
    this.getStyle = this.getStyle.bind(this)
    this.setFlowType = this.setFlowType.bind(this)
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize(entries) {
    try {
      window.parent.postMessage({
        type: 'RESIZE_MESSAGE_APROMAS',
        content: entries[0].contentRect.height,
        timestamp: new Date().toISOString()
      }, // DO NOT SEND PERSONAL OR SENSITVE INFORMATION THROUGH THIS MESSAGE FUNCTION
        // WILDCARD HAS BEEN APPLIED AS THE CURRENT ITERATION IS SAFE AND SIMPLE DATA
        '*') // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#targetorigin
    } catch (error) {
      console.error('Error sending message:', error);
    }
  }

  componentDidMount () {
    this.getCountryCode()
  }

  setFlowType (flowType) {
    this.setState({ flowType: flowType })
  }

  getResetData () {
    return {
      CurrentStep: this.state.stepId,
      IsComplete: false,
      CarData: {
        IsDirty: false,
        RegNumber: null,
        BrandNameId: null,
        Model: null,
        ChassisNumber: null,
        Km: null,
        DamageComment: null
      },
      OtherInfo: {
        IsDirty: false,
        InsuranceCompanyId: null,
        NeedRental: null,
        DamageNr: null,
        CarRentalId: null,
        DamageDate: null
      },
      ContactInfo: {
        IsDirty: false,
        ContactName: null,
        ContactLastName: null,
        ContactEmail: null,
        ContactPhone: null,
        PhoneCode: null,
        Address: null,
        ZipCode: null,
        City: null
      }
    }
  }

  getView () {
    switch (this.state.stepId) {
      case 0:
        return <IntroView onNavClick={this.onNavClick} countryCode={this.state.countryCode} flowType={this.state.flowType} setFlowType={this.setFlowType} />
      case 1:
        return <UploadPhotoView onNavClick={this.onNavClick} onBlur={this.onBlur} countryCode={this.state.countryCode} flowType={this.state.flowType}>
          {this.renderSteps()}
        </UploadPhotoView>
      case 2:
        return <CarDataView onNavClick={this.onNavClick} onBlur={this.onBlur} flowType={this.state.flowType}>
          {this.renderSteps()}
        </CarDataView>
      case 3:
        return <OtherInfoView onNavClick={this.onNavClick} onBlur={this.onBlur} flowType={this.state.flowType}>
          {this.renderSteps()}
        </OtherInfoView>
      case 4:
        return <ContactInfoView renderSteps={this.renderSteps} onNavClick={this.onNavClick} onBlur={this.onBlur} flowType={this.state.flowType}>
          {this.renderSteps()}
        </ContactInfoView>
      case 5:
        var link = document.getElementById('booking-portal-link')
        if (link && !link.href) {
          this.props.getBookingPortalRedirectUrlFromToken(this.state.companyData.Token, 'bookingportal').then(res => {
            if (res.data.BookingPortalRedirectUrl) {
              if (!res.data.BookingPortalRedirectUrl.startsWith('https://')) {
                res.data.BookingPortalRedirectUrl = 'https://' + res.data.BookingPortalRedirectUrl
              }

              link.href = res.data.BookingPortalRedirectUrl
            }
          })
        }

        return <SendView onNavClick={this.onNavClick} processing={this.state.processing} flowType={this.state.flowType}>
          {this.renderSteps()}
        </SendView>
      default:
        return null
    }
  }

  renderSteps () {
    if (this.state.stepId <= 0) return null

    const renderStep = (step, key) => {
      if (step.stepId === 0) return
      let activeClass = this.state.stepId >= step.stepId ? ' active' : ''
      let focused = this.state.stepId === step.stepId ? ' focused' : ''
      let isEarlierStep = this.state.stepId > step.stepId
      let clickable = isEarlierStep ? ' hasCursor' : ''

      const onClick = e => {
        if (isEarlierStep) this.onNavClick(e, step.stepId)
        return null
      }

      return [
        <div key={key} className={'step-circle-large' + activeClass + clickable + focused} onClick={onClick}><span>{step.stepId}</span></div>
      ]
    }

    return (
      <div className='steps'>
        <div className='stepWrapper'>
          {this.steps.map(renderStep)}
        </div>
      </div>
    )
  }

  onNavClick (e, nav) {
    new Promise((resolve, reject) => {
      if (e) e.preventDefault()
      let newStepId = this.state.stepId
      switch (nav) {
        case 'next':
          newStepId++
          break
        case 'previous':
          newStepId--
          break
        case 1:
          newStepId = 1
          break
        case 2:
          newStepId = 2
          break
        case 3:
          newStepId = 3
          break
        case 4:
          newStepId = 4
          break
        case 5:
          newStepId = 5
          break
        case 'complete':
          this.setState({ processing: true })
          let updateData = this.getResetData()
          updateData = {
            ...updateData,
            IsComplete: true,
            Consent: true
          }
          this.props.saveEmbeddedBooking(updateData).then(res => {
            let newStep = res.data.IsComplete === false ? res.data.CurrentStep : this.state.stepId
            this.setState({
              stepId: newStep
            }, () => resolve())
          }).catch((e) => {
            window.toastr.error(translation('910'), translation('216'))
            reject()
          })
          return
          // break
        case 'restart':
          this.props.logout()
          setTimeout(() => {
            this.setState({
              // flowType: 'with_regnr',
              stepId: 0,
              embedViewState: null
            })
          }, 200)
          resolve()
          return
      }

      newStepId = Math.min(5, newStepId, Math.max(0, newStepId))
      if (this.state.stepId !== newStepId) {
        this.setState({
          stepId: newStepId
        }, () => {
          resolve()
        })
      }
    })
  }

  onBlur (e, isDateTime = false) {
    let value
    let names
    let embeddedbooking = this.props.embeddedbooking
    let update = this.getResetData()
    if (isDateTime) {
      value = formatDate(e, true)
      names = 'OtherInfo.DamageDate'.split('.')

      update = {
        ...update,
        CurrentStep: this.state.stepId,
        [names[0]]: {
          ...embeddedbooking[names[0]],
          IsDirty: true,
          [names[1]]: value
        }
      }
    } else {
      let name = e.target.name
      switch (name) {   // In order to get correct autofill data for chrome
        case 'fname':
          name = 'ContactInfo.ContactName'
          break
        case 'lname':
          name = 'ContactInfo.ContactLastName'
          break
        case 'email':
          name = 'ContactInfo.ContactEmail'
          break
      }
      value = e.target.value
      names = name.split('.')
      if (names[1] === 'Km') value = parseInt(e.target.value)
      if (e.target.type === 'checkbox') value = e.target.checked

      update = {
        ...update,
        CurrentStep: this.state.stepId,
        [names[0]]: {
          ...embeddedbooking[names[0]],
          IsDirty: true,
          [names[1]]: value
        }
      }
    }

    this.props.saveEmbeddedBooking(update)
  }

  loginWithToken (token, isCreateNew) {
    this.props.loginWithToken(token, 'bookingportal').then(res => {
      // this.setView('logincomplete')
      this.onLoginComplete(isCreateNew)
    }, () => {
      this.setState({ view: 'error' })
    })
  }

  onLoginComplete (isCreateNew) {
    console.log('Authorized... createNew ? ', isCreateNew)
    this.getStyle()
    this.props.GetCarRentalAlts().then(result => {
      this.props.setEmbeddedCarRentalAlts(result.data)
    })
    this.props.getInsuranceCompanies().then(result => {
      this.props.setEmbeddedInsuranceCompanies(result.data.Item2)
    })

    if (isCreateNew) {
      this.props.saveEmbeddedBooking({ ...this.getResetData(), CurrentStep: null }).then(res => {
        console.log('Started new booking: ', res.data)
      })
    } else if (typeof isCreateNew === 'undefined') {
      this.setState({ stepId: 0 })
    }
  }

  getCountryCode () {
    let countryCode = ''
    switch (this.props.params.language.toLowerCase()) {
      case 'danish':
        countryCode = 'DK'
        break
      case 'english':
        countryCode = 'EN'
        break
      case 'swedish':
        countryCode = 'SE'
        break
      case 'norwegian':
        countryCode = 'NO'
        break
    }
    this.setState({ countryCode: countryCode })
  }

  getStyle () {
    if (this.state.companyData && this.state.companyData.Token) {
      this.setState({ isLoading: true }, () => {
        this.props.getStyle(this.state.companyData.Token, 'bookingportal').then(res => {
          this.setState({ styles: res.data, isLoading: false })
          document.querySelector('#app').style.backgroundColor = res.data.ColoredBackground
        })
      })
    }
  }

  render () {
    // Don't show page before the styling settings are loaded.
    // if (this.state.isLoading) return null // Show spinner maybe?

    let fontFamily = 'unset'
    if (this.state.styles.FontType === 1 && this.state.styles.WebSafeFont) {   // Font selected from list
      fontFamily = `"${this.state.styles.WebSafeFont}"`
    } else if (this.state.styles.FontType === 2 && this.state.styles.FontURL && this.state.styles.FontFamily) {
      fontFamily = `"${this.state.styles.FontFamily}"`
    }

    const renderStyle = () => {
      if (!this.state.styles) return null
      return (
        <style>{`
            :root{
              --webSafeFont: ${this.state.styles.WebSafeFont};
              --fontURL: ${this.state.styles.FontURL};
              --fontFamily: ${fontFamily};
              --brandColor: ${this.state.styles.BrandColor};
              --brandColorSecondary: ${this.state.styles.BrandColorSecondary};
              --primaryBackgroundColor: ${this.state.styles.PrimaryBackgroundColor};
              --coloredBackground: ${this.state.styles.ColoredBackground};
              --h1Size: ${this.state.styles.H1Size};
              --h1Color: ${this.state.styles.H1Color};
              --h2Size: ${this.state.styles.H2Size};
              --h2Color: ${this.state.styles.H2Color};
              --bodySize: ${this.state.styles.BodySize};
              --bodyColor: ${this.state.styles.BodyColor};
              --navigationSize: ${this.state.styles.NavigationSize};
              --navigationColor: ${this.state.styles.NavigationColor};
              --linkSize: ${this.state.styles.LinkSize};
              --linkColor: ${this.state.styles.LinkColor};
              --buttonTextSize: ${this.state.styles.ButtonTextSize};
              --buttonTextColor: ${this.state.styles.ButtonTextColor};
              --buttonStrokeColor: ${this.state.styles.ButtonStrokeColor};
              --buttonFillColor: ${this.state.styles.ButtonFillColor};
              --hoverStrokeColor: ${this.state.styles.HoverStrokeColor};
              --hoverFillColor: ${this.state.styles.HoverFillColor};
              --checkboxColor: ${this.state.styles.CheckboxColor};
              --checkboxActiveColor: ${this.state.styles.CheckboxActiveColor};
              --backButtonTextSize: ${this.state.styles.BackButtonTextSize};
              --backButtonTextColor: ${this.state.styles.BackButtonTextColor};
              --backButtonStrokeColor: ${this.state.styles.BackButtonStrokeColor};
              --backButtonFillColor: ${this.state.styles.BackButtonFillColor};
              --backButtonHoverStrokeColor: ${this.state.styles.BackButtonHoverStrokeColor};
              --backButtonHoverFillColor: ${this.state.styles.BackButtonHoverFillColor};
              --inputFieldColor: ${this.state.styles.InputFieldColor};
              --inputFieldTextColor: ${this.state.styles.InputFieldTextColor};
              --emptyFieldTextColor: ${this.state.styles.EmptyFieldTextColor};
              --emptyFieldTextSize: ${this.state.styles.EmptyFieldTextSize};             
            }
          .ff-wrap{
            font-family: ${fontFamily};
          }
          .color-wrap{
            color: ${this.state.styles.BodyColor};
          }
          .branch-color{
            color: ${this.state.styles.BrandColor};
          }
          .branch-bg{
            background: ${this.state.styles.BrandColor};
          }
          .branch-border{
            border-color: ${this.state.styles.BrandColor};
          }
          .fz-wrap{
            font-size: ${this.state.styles.BodySize};
          }
          .h1-color{
            color: ${this.state.styles.H1Color};
          }
          .h1-fz{
            font-size: ${this.state.styles.H1Size};
          }
          .h2-color{
            color: ${this.state.styles.H2Color};
            font-weight: 700;
          }
          .h2-fz{
            font-size: ${this.state.styles.H2Size};
          }
          .nav-color{
            color: ${this.state.styles.NavigationColor};
          }
          .nav-fz{
            font-size: ${this.state.styles.NavigationSize};
          }
          .link-color{
            color: ${this.state.styles.LinkColor};
          }
          .link-fz{
            font-size: ${this.state.styles.LinkSize};
          }
        `}</style>
      )
    }

    const onCompanyDataReceived = (companyData) => {
      this.setState({ companyData: companyData[0] }, () => {
        this.getStyle()
        this.loginWithToken(companyData[0].Token, true)
      })
    }

    if (this.state.stepId === 0) {
      return (
        <ResizeDetector onResize={this.handleResize}>
          <div className="embeddedbooking">
            {this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' &&
              <RenderFontURL url={this.state.styles.FontURL}/>}
            {renderStyle()}
            <IntroView companyData={this.state.companyData} onNavClick={this.onNavClick}
                       embedToken={this.props.params.embedToken}
                       countryCode={this.state.countryCode}
                       flowType={this.state.flowType}
                       setFlowType={this.setFlowType}
            >
              <EmbedView
                notAvailableMsg={translation(16684)}
                configErrorMsg={translation('There seems to be a configuration error with the booking portal!')}
                embedToken={this.props.params.embedToken}
                language={this.props.params.language}
                embedType={'bookingportal'}
                view={this.state.embedViewState}
                onViewChange={(newView) => this.setState({ embedViewState: newView })}
                onLoginComplete={this.onLoginComplete}
                onCompanyTokensReceived={onCompanyDataReceived}
              />
            </IntroView>
          </div>
        </ResizeDetector>
      )
    }

    return (
      <ResizeDetector onResize={this.handleResize}>
        <div className="embeddedbooking">
          {this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' &&
            <RenderFontURL url={this.state.styles.FontURL}/>}
          {renderStyle()}
          <Link id="booking-portal-link" to={''}/>
          <EmbedView
            embedToken={this.props.params.embedToken}
            embedType={'bookingportal'}
            view={this.state.embedViewState}
            onViewChange={(newView) => this.setState({ embedViewState: newView })}
          >
            {this.getView()}
          </EmbedView>
        </div>
      </ResizeDetector>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common,
    carData: state.embeddedbooking.CarData,
    images: state.embeddedbooking.Images,
    otherInfo: state.embeddedbooking.OtherInfo,
    contactInfo: state.embeddedbooking.ContactInfo,
    embeddedbooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, {
  saveEmbeddedBooking,
  setEmbeddedInsuranceCompanies,
  setEmbeddedCarRentalAlts,
  getBookingPortalRedirectUrlFromToken,
  getInsuranceCompanies,
  loginWithToken,
  logout,
  GetCarRentalAlts,
  getStyle })(EmbeddedBooking)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/index.js